module.exports = __webpack_public_path__ + "img/widget-img_stars.0e93988e.png";